<template>
    <div class="app-container">
        <tab-year @func="handleTabYear" ref="year"></tab-year>
        <div class="filter-container">
            <el-input
                style="width: 150px;"
                class="filter-item"
                placeholder="报考院校"
                v-model="listQuery.school"
            ></el-input>
            <el-input
                style="width: 150px;"
                class="filter-item"
                placeholder="报考专业"
                v-model="listQuery.major"
            ></el-input>
            <el-select
                clearable
                style="width: 150px"
                class="filter-item"
                v-model="listQuery.source"
                placeholder="网站来源"
            >
                <el-option
                    v-for="item in sourceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
            </el-select>
            <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
            >搜索</el-button>
            <el-button
                class="filter-item"
                @click="$refs.edit.handleAdd(yearName)"
                type="primary"
                icon="el-icon-edit"
                v-permission="['query.edit_article_admin']"
            >添加</el-button>
        </div>
        <el-table
            :data="list"
            v-loading="listLoading"
            element-loading-text="加载中 ..."
            border
            highlight-current-row
            max-height="550"
        >
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column label="文章标题" width="200" prop="title" show-overflow-tooltip></el-table-column>
            <el-table-column label="作者" width="100" prop="author"></el-table-column>
            <el-table-column label="报考院校" width="200" prop="school" show-overflow-tooltip></el-table-column>
            <el-table-column label="报考专业及代码" width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p class="link" @click="searchMajor(scope.row.major)">{{ scope.row.major }}</p>
                    <!-- <router-link v-if="scope.row.major_uuid" class="link" :to="'/colleges/catalog/major-info/' + scope.row.major_uuid">{{ scope.row.major }}</router-link>
                    <p v-else>{{ scope.row.major }}</p>-->
                </template>
            </el-table-column>
            <el-table-column label="来源网站" width="120" align="center" prop="get_source_display"></el-table-column>
            <el-table-column label="发布日期" width="200" prop="release_time"></el-table-column>
            <el-table-column label="操作" min-width="200px" fixed="right">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="$refs.detail.handleDetail(scope.row.uuid)"
                    >查看</el-button>
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-edit"
                        v-permission="['query.edit_article_admin']"
                        @click="$refs.edit.handleEdit(yearName,scope.row.uuid)"
                    ></el-button>
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-delete"
                        v-permission="['query.edit_article_admin']"
                        @click="handleDel(scope.row.uuid)"
                    ></el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <pagination
                :total="count"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.size"
                @pagination="fetchData(yearName)"
            />
        </div>
        <detail ref="detail" />
        <edit ref="edit" :sourceOptions="sourceOptions" />
    </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import TabYear from "@/components/TabYear";
import { getList, del } from "@/api/article";
import Edit from "./components/Edit";
import Detail from "./components/Detail";
export default {
    name: "DispensingIndex",
    data() {
        return {
            school_uuid: "",
            list: [],
            yearName: "",
            count: 0,
            listLoading: true,
            nav_source: null,
            listQuery: {
                page: 1,
                size: 50,
                school: "",
                major: "",
                source: ""
            },
            sourceOptions: [
                { label: "百度贴吧", value: 1 },
                { label: "考研帮", value: 2 },
                { label: "小红书", value: 3 },
                { label: "知乎", value: 4 },
                { label: "豆瓣", value: 5 },
                { label: "微博", value: 6 },
                { label: "百度知道", value: 7 },
                { label: "简书", value: 8 }
            ]
        };
    },
    components: {
        TabYear,
        Edit,
        Detail
    },
    created() {},
    methods: {
        checkPermission,
        handleTabYear(year) {
            this.yearName = year;
            this.fetchData(year);
        },
        fetchData(year) {
            this.listLoading = true;
            getList(year, this.listQuery).then(res => {
                this.list = res.data.results;
                this.count = res.data.count;
                this.listLoading = false;
            });
        },
        // 筛选
        handleFilter() {
            Object.assign(this.listQuery, {
                page: 1
            });
            this.fetchData(this.yearName);
        },
        // 点击表格筛选
        searchMajor(major) {
            Object.assign(this.listQuery, {
                page: 1,
                major
            });
            this.fetchData(this.yearName);
        },
        // 删除
        handleDel(uuid) {
            this.$confirm("确认删除该项目吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    del(uuid).then(() => {
                        this.$notify({
                            title: "成功",
                            message: "删除成功",
                            type: "success"
                        });
                        if (this.list.length == 1 && this.listQuery.page > 1) {
                            Object.assign(this.listQuery, {
                                page: this.listQuery - 1
                            });
                        }
                        this.fetchData(this.yearName);
                    });
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="less" scoped>
.app-container {
    padding-top: 10px;
}
.link {
    color: #409eff;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
        cursor: pointer;
    }
}
</style>

